import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// When the browser is on a customer's own custom domain (e.g.
// `https://sarvsiddhi.org`), do NOT hit the platform's canonical
// `${BACKEND_URL}/api/*` URL — that would be cross-origin, which:
//   1. Breaks the session cookie (Set-Cookie is scoped to the platform host)
//   2. Requires CORS + credentials wiring that browsers routinely refuse
// Approximated already reverse-proxies `/api/*` from the tenant host to the
// platform backend, so a relative `/api` base is same-origin and cookies stick.
function _resolveApiBase() {
  if (typeof window === "undefined") return `${BACKEND_URL}/api`;
  let platformHost = "";
  try { platformHost = new URL(BACKEND_URL).host; } catch { /* noop */ }
  const currentHost = window.location.host;
  const isCustomDomain = platformHost && currentHost && currentHost !== platformHost;
  return isCustomDomain ? "/api" : `${BACKEND_URL}/api`;
}
export const API_BASE = _resolveApiBase();

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail === "object" && typeof detail.message === "string") return detail.message;
  return String(detail);
}

// Global 402 Payment Required — plan-based limits. Show a friendly upgrade toast
// so every create-flow gets the same "Upgrade" affordance without repeating code.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 402) {
      const d = err.response.data?.detail;
      const msg = formatApiErrorDetail(d);
      toast.error(msg, {
        action: {
          label: "Upgrade",
          onClick: () => { window.location.assign("/app/plans"); },
        },
        duration: 6000,
      });
    }
    return Promise.reject(err);
  }
);

export default api;
